module.exports = __webpack_public_path__ + "img/handraw_moins orange copie.00dcc00f.svg";